var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-icon',[_vm._v("mdi-alert-circle-outline")]),_c('p',[_vm._v("A fatal error occured!")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }